import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function register() {
  const axios = axiosInstance().primoLab;
  let data = {};

  await axios
    .post("/2fa/register")
    .then(async (response) => {
      data = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { data };
}
